import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 待機者 API 操作クラス
 */
export default class FollowerMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET FollowerMessages
   */
  public async getsInFacility(userStore: LoginUser, queryParams?: { startIndex?: number; endIndex?: number }): Promise<Array<FollowerMessagesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.FollowerMessages, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<FollowerMessagesGetModel>>(userStore, requestUrl, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST FollowerMessages
   */
  public async post(userStore: LoginUser, requestBody: FollowerMessagesPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.FollowerMessages, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface FollowerMessagesGetModel {
  /** 施設を示す ID */
  facilityId: number;
  /** 送信日時 */
  datetime: number;
  /** タイトル */
  title: string;
  /** 本文 */
  text: string;
  /** 宛先情報 */
  to: Array<Target>;
  /** 添付ファイル */
  files: Array<File>;
  /** 送信ユーザーID */
  userId: string;
  /** 送信ユーザー名 */
  userName: string;

  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 最終更新日 */
  updated: number;
  /** 作成した日付(YYYYMMDDhhmmssSSS) */
  created: number;
}

export interface Target {
  /** 宛先（LINEID または メールアドレス） */
  address: string;
  /** 宛先種別 */
  addressType: AddressType;
  /** 氏名 */
  name: string | null;
}

export enum AddressType {
  LINE = "line",
  MAIL = "mail"
}

export interface File {
  /** ファイル名 */
  name: string;
  /** S3ファイルURL */
  url: string;
  /** ファイル種別文字列（mime-type） */
  type: string;
}

export interface FollowerMessagesPostModel {
  /** メッセージタイトル */
  title: string;
  /** メッセージ本文 */
  text: string;
  /** ファイル */
  files: Array<File>;
}
